export enum RoleName {
  ADMINISTRATOR = 'Administrator',
  USER = 'User',
  SALES = 'Sales Executive',
  SERVICE = 'Customer Service',
  SERVICE1 = 'Customer Service Executive',
  SERVICE2 = 'Customer Service Manager',
  PHARMACIST = 'Pharmacist',
}
